import { PageRouteBuilder } from "@common/route/page-route-builder";
import { TriggerEventSchedulerComponent } from "./trigger-event-scheduler.component";

export const triggerEventSchedulerRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-trigger-event-scheduler", TriggerEventSchedulerComponent)
    .requiresLogin()
    .atUrl("/tools/trigger-event-scheduler")
    .withTitle("Trigger Event Scheduler Checks")
    .build();
